import React from "react";

import { isEmbedded } from "../features/auth/lucimixHandshake";

// 产品决定（2026-10-28）：在 Lucimix 里切到别的应用再切回来，一律回概览，不保留上次看的页面。
// Lucimix 切走时把 iframe 外层设成 display:none（iframe 不重载），切回来再显示（2026-10-28 在 lucimix.cn 读页面结构确认）。
// 信号用 IntersectionObserver：隐藏时 isIntersecting=false，显示时变回 true。
// 窗口宽度不会变（Chromium 保留隐藏前的尺寸）、visibilitychange 也不触发，这两条都实测过不能用。
// ponytail: 依赖 Lucimix「隐藏而不销毁」的做法；它哪天改成重载 iframe，这里自然不再触发（重载本来就回首页）。
export function useReturnHomeOnReshow(navigate) {
  React.useEffect(() => {
    if (!isEmbedded() || typeof IntersectionObserver === "undefined") return undefined;
    let hidden = false;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        hidden = true;
        return;
      }
      if (!hidden) return;
      hidden = false;
      navigate("/overview", { replace: true });
    });
    observer.observe(document.documentElement);
    return () => observer.disconnect();
  }, [navigate]);
}
